import { AxiosResponse } from 'axios';
import ApiService, { ApiArguments } from '@/api/api_service';
import {
  TranscriptionSummarizationApi,
  TranscriptionSummarizationApiGetTranscriptionSummarizationRequest,
  GetTranscriptionSummarization200Response,
  TranscriptionSummarizationApiPostTranscriptionSummarizeRequest,
} from '@/api/openapi';

export class TranscriptionSummarizationApiService extends ApiService {
  api = new TranscriptionSummarizationApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getTranscriptionSummarization(
    {
      request,
      options,
      errorHandlers,
    }: ApiArguments<TranscriptionSummarizationApiGetTranscriptionSummarizationRequest>,
  ): Promise<AxiosResponse<GetTranscriptionSummarization200Response>> {
    return this.checkResponse<GetTranscriptionSummarization200Response>(
      this.api.getTranscriptionSummarization(request, options),
      errorHandlers,
    );
  }

  async postTranscriptionSummarize({
    request,
    options,
    errorHandlers,
  }: ApiArguments<TranscriptionSummarizationApiPostTranscriptionSummarizeRequest>) {
    return this.checkResponse<void>(
      this.api.postTranscriptionSummarize(request, options),
      errorHandlers,
    );
  }
}
